/* eslint-disable */
import vuetify from 'vuetify/lib/locale/es'

const labels = {
    dashboard: 'Panel de Control',
    demand: 'Demanda',
    demands: 'Demandas',
    contract: 'Contrato',
    contracts: 'Contratos',
    corporate: 'Corporativo',
    brand: 'Marca',
    brands: 'Marcas',
    department: 'Departamento',
    departments: 'Departamentos',
    teamMember: 'Miembro del Equipo',
    teamMembers: 'Miembros del Equipo',
    legalTeam: 'Equipo Legal',
    notification: 'Notificación',
    notifications: 'Notificaciones',
    portfolio: 'Portafolio',
    portfolios: 'Portafolios',
    teamMemberPortfolio: 'Equipo',
    activeDemands: 'Demandas Activas',
    demandsCompleted: 'Demandas Completadas',
    workedHours: 'Horas Trabajadas',
    info: 'Información',
    timeline: 'Cronología'
};

const common = {
    meta: {
        title: 'Tasklaw - %page',
        description: 'Con nuestra calculadora corporativa, puedes gestionar tu captable, opciones sobre acciones e información sobre tu participación accionaria en la empresa, considerando el tamaño de la ronda, la valoración y otros factores.',
        keywords: 'calculadora,corporativa,captable,capital,acciones,empresa,opciones,jurídico,acciones,cuotas,porcentaje,software,socios,accionistas,ronda,inversión,gráfico,historial,capital,corporativo,participación,sociedad'
    },
    filter: {
        componentName: 'Filtros',
        searchFor: 'Buscar',
        byCompany: 'Filtrar por empresa',
        byDepartment: 'Filtrar por departamento',
        byResponsible: 'Filtrar por responsable',
        clearFilter: 'Limpiar filtro',
        applyFilter: 'Aplicar filtro'
    },
    search: {
        field: 'Buscar',
        button: 'Buscar'
    },
    showInactives: '¿Mostrar inactivos?',
    dataTable: {
        headers: {
            name: 'Nombre',
            activeDemands: labels.activeDemands,
            demandsCompleted: labels.demandsCompleted,
            workedHours: labels.workedHours,
            actions: 'Acciones'
        },
        loadingText: 'Cargando... por favor espera',
        noDataText: 'No se encontraron registros',
        deleteConfirm: '¿Estás seguro de que deseas eliminar esto?',
        view: 'Ver'
    },
    save: 'Guardar',
    add: 'Agregar',
    edit: 'Editar',
    change: 'Cambiar',
    close: 'Cerrar',
    update: 'Actualizar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    remove: 'Eliminar',
    details: 'Detalles',
    delete: 'Borrar',
    previous: 'Anterior',
    next: 'Siguiente',
    notInformed: 'No informado',
    yes: 'Sí',
    no: 'No',
    loadMore: 'Cargar más',
    editorEmptyNodeText: 'Escribe una pregunta o una actualización...',
    editorObservationEmptyNodeText: 'Escribe una observación...',
    noDataText: 'No se encontraron registros',
    timeline: {
        componentName: labels.timeline,
        newInteraction: 'Nueva Interacción',
        correctDate: {
            label: 'Fecha de Inicio (Requerida)',
            rule: 'La fecha de inicio es requerida'
        },
        category: {
            label: 'Categoría (Requerida)',
            labelFilter: 'Filtrar por categoría',
            rule: 'La categoría es requerida',
            items: {
                noteFile: 'Nota/Archivo',
                meeting: 'Reunión',
                phone: 'Llamada Telefónica',
                email: 'Correo Electrónico',
                charge: 'Cobro'
            }
        },
        alerts: {        
            saveError: 'No se pudo guardar la interacción',
            addCommentOrFile: 'Agrega un comentario o un archivo',
            deleteConfirm: '¿Estás seguro de que deseas eliminar esta interacción?',
            deleteSuccess: '¡Interacción eliminada con éxito!'
        }
    },
    tabDemands: {
        addItem: 'Registrar Demanda',
        tabs: {
            actives: 'Activas',
            completeds: 'Completadas',
            standby: 'En Espera'
        },
        dataTable: {
            headers: {
                client: 'Cliente',
                startDate: 'Fecha de Inicio',
                demand: labels.demand,
                currentTask: 'Tarea Actual',
                nextTask: 'Próxima Tarea',
                deadlineDate: 'Fecha Límite',
                status: 'Estado',
                workedHours: 'Horas Trabajadas',
                endDate: 'Fecha de Finalización',
                responsibleName: 'Responsable',
            }
        }
    },
    checkAll: 'Seleccionar Todo',
    uncheckAll: 'Deseleccionar Todo',
    fileInfo: {
        delete: 'Eliminar',
        download: 'Descargar',
        confirm: '¿Estás seguro de que deseas eliminar el archivo?',
        success: 'Archivo eliminado con éxito'
    },
    chat: {
        action: 'Usar IA',
        title: 'Chat',
        you: 'Tú',
        system: 'Sistema',
        message: 'Escribe tu mensaje',
        error: '¡Ocurrió un error!'
    },
    errorSave: '¡Ocurrió un error al guardar!',
    admin: 'Administrador',
    noAdmin: 'No administrador'
};

const demand = {
    status: {
        pending: "Pendiente",
        starting: "Iniciado",
        waiting: "Esperando",
        standby: "En Espera",
        finished: "Finalizado",
        canceled: "Cancelado",
    },
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.demands),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        filter: {
            fromDate: 'Filtrar por fecha de inicio',
            toDate: 'Filtrar por fecha de finalización',
            client: 'Filtrar por empresa',
            department: 'Filtrar por departamento',
            manager: 'Filtrar por socio',
            responsible: 'Filtrar por responsable',
            status: 'Filtrar por estado'
        },
        addItem: 'Registrar Demanda',
        dataTable: {
            itemName: labels.demand.toLowerCase(),
            headers: {
                client: 'Empresa',
                startDate: 'Fecha de Inicio',
                demand: labels.demand,
                currentTask: 'Tarea Actual',
                nextTask: 'Próxima Tarea',
                deadlineDate: 'Fecha Límite',
                status: 'Estado',
                responsible: 'Responsable'
            }
        }
    },
    form: {
        metaNew: {
            title: common.meta.title.replace('%page', 'Registrar Demanda'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: common.meta.title.replace('%page', 'Detalle de la Demanda'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'Nueva Demanda',
        titleDetail: 'Detalle de la Demanda',
        data: 'Datos de la Demanda',
        isExternalDemand: '¿Es esta una demanda externa?',
        demand: {
            label: 'Demanda (Requerida)',
            required: 'La demanda es requerida',
            length: 'La demanda debe tener al menos 3 caracteres'
        },
        requester: {
            label: 'Solicitante'
        },
        client: {
            label: 'Buscar cliente (Requerido)',
            required: 'El cliente es requerido'
        },
        department: {
            label: 'Buscar departamento'
        },
        responsible: {
            label: 'Buscar personas responsables (Requerido)',
            length: 'El responsable es requerido'
        },
        status: {
            label: 'Estado (Requerido)',
            required: 'El estado es requerido'
        },
        startDate: {
            label: 'Fecha de Inicio (Requerido)',
            required: 'La fecha de inicio es requerida'
        },
        deadlineDate: {
            label: 'Fecha Límite',
            labelRequired: 'Fecha Límite (Requerida)',
            required: 'La fecha límite es requerida'
        },
        manager: {
            label: 'Buscar socio (Requerido)',
            required: 'El socio es requerido'
        },
        workedHours: {
            label: 'Horas Trabajadas',
            data: 'Nuevo registro de horas trabajadas',
            time: {
                label: 'Horas Trabajadas',
                rule: 'Las horas trabajadas son requeridas'
            },
            registerDate: {
                label: 'Fecha de Registro (Requerido)',
                rule: 'La fecha de registro es requerida'
            }
        },
        tasks: {
            data: 'Tareas',
            task: {
                label: 'Nueva Tarea',
                rule: 'Las horas trabajadas son requeridas'
            },
            hideDoneTasks: 'Ocultar tareas completadas',
            showDoneTasks: 'Mostrar tareas completadas'
        },
        timeline: {
            isPrivate: 'Privado',
            totalFiles: 'Total de archivos:',
            correctDate: {
                label: 'Fecha (Requerido)',
                rule: 'La fecha es requerida'
            },
            confirm: '¿Estás seguro de que deseas eliminar esta interacción?',
            success: '¡Interacción eliminada con éxito!',
            errors: {
                save: 'No se pudo guardar la interacción',
                commentFile: 'Agrega un Comentario o un Archivo'
            }
        }
    }
};

const contracts = {
    status: {
        items: {
            draft: 'Borradores',
            signatures: 'Firmas',
            active: 'Activo',
            renewal: 'Renovación',
            rescinded: 'Rescindido',
            terminated: 'Terminado'
        }
    },
    list: {
        meta: {
            title: 'Tasklaw - Contratos',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        filter: {
            fromDate: 'Filtrar por Fecha de Inicio',
            toDate: 'Filtrar por Fecha de Fin',
            status: 'Filtrar por Estado',
            part: 'Filtrar por Parte',
            department: 'Filtrar por Departamento',
            client: 'Filtrar por Empresa'
        },
        addItem: 'Registrar Contrato',
        dataTable: {
            itemName: labels.contract.toLowerCase(),
            headers: {
                client: 'Empresa',
                department: 'Departamento',
                contract: 'Contrato',
                typePart: 'Mi Parte',
                part: 'Parte Principal',
                deadline: 'Plazo Actual',
                validity: 'Validez',
                status: 'Estado',
                pendingAdditive: 'Adenda Pendiente',
                actions: common.dataTable.headers.actions
            }
        },
        successDelete: '¡Contrato eliminado con éxito!',
        error: '¡Ocurrió un error!',
        deleteMsg: '¡Marca eliminada con éxito!'
    },
    form: {
        metaNew: {
            title: 'Tasklaw - Nuevo Contrato',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: 'Tasklaw - Detalles del Contrato',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'Nuevo Contrato',
        titleDetail: 'Detalles del Contrato',
        data: 'Datos del Contrato',
        contract: {
            label: 'Contrato (Obligatorio)',
            required: 'El contrato es obligatorio',
            length: 'El contrato debe tener al menos 3 caracteres'
        },
        client: {
            label: 'Buscar Empresa (Obligatorio)',
            required: 'La empresa es obligatoria'
        },
        department: {
            label: 'Buscar Departamento'
        },
        partField: {
            label: 'Parte (Obligatorio)',
            required: 'La parte es obligatoria'
        },
        typePart: {
            label: 'Parte (Obligatorio)',
            required: 'La otra parte es obligatoria',
            length: 'La parte debe tener al menos 3 caracteres'
        },
        validity: {
            switch: '¿Validez indeterminada?',
            label: 'Validez del Contrato (Obligatorio)',
            required: 'La validez del contrato es obligatoria',
            dateRequired: 'La fecha de validez es obligatoria'
        },
        status: {
            label: 'Estado (Obligatorio)',
            required: 'El estado es obligatorio'
        },
        observation: 'Observaciones',
        objectContract: {
            label: 'Objeto del Contrato',
            required: 'El objeto del contrato es obligatorio'
        },
        part: {
            title: 'Otras Partes del Contrato',
            empty: '¡No hay partes registradas en este contrato!',
            isMainPart: '(Parte Principal)',
            setMainPart: 'Establecer como Principal',
            showOnlyMainPart: 'Mostrar Solo Parte Principal',
            showAllParts: 'Ver Todas las Partes en el Contrato'
        },
        partDialog: {
            title: 'Nueva Parte en el Contrato',
            type: {
                label: 'Parte',
                required: 'La parte es obligatoria',
                length: 'La parte debe tener al menos 3 caracteres',
            },
            name: {
                label: 'Nombre de la Parte',
                required: 'El nombre de la parte es obligatorio',
                length: 'El nombre de la parte debe tener al menos 3 caracteres'
            },
            part: {
                label: 'Parte'
            }
        },
        fileUpload: {
            title: 'Archivo del Contrato',
            empty: '¡No hay archivo adjunto!',
            tip: 'Arrastra y suelta el archivo aquí o haz clic en el botón de abajo.',
            action: 'Adjuntar'
        },
        deadline: {
            title: 'Plazos del Contrato',
            empty: '¡No hay plazos registrados en este contrato!',
            hideDones: 'Ocultar Plazos Completados',
            showDones: 'Ver Plazos Completados'
        },
        deadlineDialog: {
            title: 'Nuevo Plazo del Contrato',
            deadline: {
                label: 'Fecha de Plazo (Obligatorio)',
                required: 'La fecha de plazo es obligatoria'
            },
            name: {
                label: 'Nuevo Plazo',
                required: 'El nombre del plazo es obligatorio',
                length: 'El nombre del plazo debe tener al menos 3 caracteres'
            }
        },
        additive: {
            title: 'Adendas del Contrato',
            empty: '¡No hay adendas registradas en este contrato!',
            status: 'Estado de la Adenda:',
            signDate: 'Fecha de Firma:',
            cancelDate: 'Fecha de Cancelación:',
            hideCanceleds: 'Ocultar Adendas Canceladas',
            showCanceleds: 'Mostrar Adendas Canceladas'
        },
        additiveDialog: {
            title: 'Adenda del Contrato',
            empty: '¡No hay objeto de contrato adjunto!',
            additive: {
                label: 'Nombre (Obligatorio)',
                required: 'El nombre es obligatorio',
                length: 'El nombre debe tener al menos 3 caracteres'
            },
            description: 'Descripción y Objeto de la Adenda',
            reasonCancellation: {
                label: 'Motivo de la Cancelación (Obligatorio)',
                required: 'El motivo de la cancelación es obligatorio'
            },
            addendumDate: {
                label: 'Fecha de Creación (Obligatorio)',
                required: 'La fecha de creación de la adenda es obligatoria'
            },
            signatureDate: {
                label: 'Fecha de Firma (Obligatorio)',
                required: 'La fecha de firma de la adenda es obligatoria'
            },
            cancellationDate: {
                label: 'Fecha de Cancelación (Obligatorio)',
                required: 'La fecha de cancelación de la adenda es obligatoria'
            },
            status: {
                label: 'Estado (Obligatorio)',
                required: 'El estado es obligatorio',
                items: {
                    pending: 'Pendiente',
                    sign: 'Firmado',
                    canceled: 'Cancelado'
                }
            }
        }
    }
};

const corporate = {
    meta: {
        title: 'Tasklaw - Corporativo',
        description: common.meta.description,
        keywords: common.meta.keywords
    },
    tabs: {
        captable: 'Tabla de Capitalización',
        administration: 'Administración',
        constitutiveActs: 'Actos Constitutivos'
    },
    client: {
        label: common.filter.byCompany,
    },
    captable: {
        companyInfo: {
            update: 'Actualizar Datos',
            socialReason: 'Nombre de la Empresa',
            socialObjects: 'Objetivos Sociales',
            CNAES: 'CNAES',
            headquarters: 'Sede',
            companyType: {
                label: 'Tipo Corporativo',
                required: 'El tipo corporativo es obligatorio',
                items: {
                    sa: 'S.A.',
                    ltda: 'Ltda'
                }
            },
            meetingDate: {
                label: 'Fecha AGO',
                required: 'La fecha es obligatoria'
            },
            shareCapitalLabel: 'Total Acciones',
            totalActions: 'Total Acciones',
            totalQuotas: 'Total Cuotas',
            agoDate: 'Fecha AGO',
            partnersMeetingDate: 'Fecha de Reunión de Socios'
        },
        current: {
            title: 'Tabla de Capitalización Actual',
            empty: '¡No hay entradas actuales en este momento!',
        },
        history: {
            title: 'Historial de Tabla de Capitalización',
            empty: '¡No hay historial en este momento!',
            headers: {
                shareholder: 'Accionista',
                actions: 'Acciones',
                percentual: '%',
                partners: 'Socios',
                quotas: 'Cuotas'
            },
            total: 'Total',
            deleteConfirm: '¿Estás seguro de que deseas eliminar esta tabla de capitalización?',
            deleteSuccess: '¡Tabla de capitalización eliminada con éxito!'
        },
        form: {
            titleNew: 'Nueva Entrada',
            titleDetail: 'Detalles de la Entrada',
            data: 'Datos de la Entrada',
            memberTypeShareholders: 'Accionistas',
            shareTypeActions: 'Acciones',
            memberTypePartners: 'Socios',
            shareTypeQuotas: 'Cuotas',
            shareCapitalInitial: 'Cuotas Iniciales',
            shareCapitalBase: 'Cuotas Actualizadas',
            buttonLabelAdd: 'Agregar',
            buttonLabelEdit: 'Editar',
            groupEntry: '¿Agrupar entrada %?',
            columns: {
                name: 'Nombre',
                percentual: 'Porcentaje',
                shares: 'Acciones',
                stakes: 'Cuotas'
            },
            empty: '¡No hay miembros registrados!',
            shareNumberRounded: '* El número de %form.shareType% se redondea al número entero más cercano *',
            unlockChanges: 'Desbloquear cambios',
            lockChanges: 'Bloquear cambios',
            calc: 'Calcular',
            reInit: 'Reiniciar',
            title: {
                label: 'Título (Obligatorio)',
                required: 'El título es obligatorio',
                length: 'El título debe tener al menos 3 caracteres'
            },
            shareCapitalInitial: {
                label: 'Acciones Iniciales',
                required: 'Las acciones iniciales son obligatorias',
                length: 'Las acciones iniciales deben ser positivas'
            },
            shareCapitalBase: {
                label: 'Acciones Actualizadas',
                required: 'Las acciones actualizadas son obligatorias',
                length: 'Las acciones actualizadas deben ser positivas'
            },
            required: 'Requerido',
            member: {
                required: 'El miembro es obligatorio',
                length: 'El título debe tener al menos 3 caracteres'
            },
            shares: {
                required: 'Las acciones son obligatorias',
                length: 'Las acciones deben ser positivas'
            },
            percentual: {
                required: 'El porcentaje es obligatorio',
                length: 'El porcentaje debe ser positivo',
                lengthMore: 'El porcentaje no puede superar el 100%'
            },
            fixedError: 'Cálculo incorrecto: la suma de porcentajes fijos es 100% o más!',
            addedError: 'Cálculo incorrecto: la suma de porcentajes añadidos es 100% o más!',
            fixedAddedError: 'Cálculo incorrecto: la suma de porcentajes fijos y añadidos es 100% o más!',
            missingMembers: '¡Necesitas agregar miembros!'
        }
    },
    administration: {
        titleSA: 'Consejo de Administración',
        titleLTDA: 'Directores/Administradores',
        current: {
            empty: '¡No hay miembros en este momento!',
        },
        history: {
            title: 'Historial de %title%',
            empty: '¡No hay historial en este momento!',
            registerDate: 'Fecha de Registro:',
            admitted: 'Admitido',
            destitute: 'Destituido',
            headers: {
                name: 'Directores/Administradores',
                nameSA: 'Consejo de Administración',
                position: 'Cargo',
                election: 'Elección',
                mandate: 'Mandato',
                deprived: 'Destituido'
            },
            deleteConfirm: '¿Estás seguro de que deseas eliminar este registro?',
            deleteSuccess: '¡Registro eliminado con éxito!'
        },
        form: {
            titleNew: 'Nueva Entrada',
            titleDetail: 'Detalles de la Entrada',
            data: 'Datos de la Entrada',
            memberTypeLTDA: 'Directores/Administradores',
            memberTypeSA: 'Consejo de Administración',
            admitted: '(Admitido)',
            destitute: '(Destituido)',
            empty: '¡No hay miembros registrados!',
            dismiss: 'Destituir',
            refund: 'Reintegrar',
            date: {
                label: 'Fecha de Registro (Obligatoria)',
                required: 'La fecha de registro es obligatoria'
            },
            member: {
                label: 'Nombre (Obligatorio)',
                required: 'El nombre es obligatorio',
                length: 'El nombre debe tener al menos 3 caracteres'
            },
            position: {
                label: 'Cargo (Obligatorio)',
                required: 'El cargo es obligatorio',
                length: 'El cargo debe tener al menos 3 caracteres'
            },
            mandate: {
                label: '¿Mandato Indeterminado?',
                required: 'La fecha de mandato es obligatoria',
                length: 'El mandato debe tener al menos 3 caracteres',
                undetermined: 'Indeterminado'
            },
            election: {
                label: 'Elección (Obligatorio)',
                required: 'La fecha de elección es obligatoria'
            },
            deprived: {
                label: 'Destitución (Obligatorio)',
                required: 'La fecha de destitución es obligatoria'
            }
        }
    },
    constitutiveActs: {
        fromDate: 'Después de',
        toDate: 'Antes de',
        dataTable: {
            itemName: 'Acto Constitutivo',
            headers: {
                date: 'Fecha',
                title: 'Título',
                resume: 'Resumen',
                file: 'Adjunto',
                actions: 'Acciones'
            }
        },
        form: {
            header: 'Acto Constitutivo',
            filePreviewEmpty: '¡No hay archivo adjunto del acto!',
            title: {
                label: 'Título (Obligatorio)',
                required: 'El título es obligatorio',
                length: 'El título debe tener al menos 3 caracteres'
            },
            description: {
                label: 'Resumen del Acto y Archivo',
            },
            time: {
                label: 'Hora (Obligatoria)',
                required: 'La hora es obligatoria'
            },
            date: {
                label: 'Fecha (Obligatoria)',
                required: 'La fecha es obligatoria'
            },
            needFile: 'Debe adjuntar un archivo.',
            needResume: 'Debe llenar el resumen.'
        }
    }
};

const brands = {
    list: {
        meta: {
            title: 'Tasklaw - Marcas',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Registrar Marca',
        dataTable: {
            itemName: labels.brand.toLowerCase(),
            headers: {
                company: 'Empresa',
                process: 'Proceso',
                brand: 'Marca',
                presentation: 'Presentación',
                nature: 'Naturaleza',
                class: 'Clase',
                situation: 'Situación',
                actions: 'Acciones'
            }
        },
        deleteMsg: '¡Marca eliminada con éxito!'
    },
    form: {
        metaNew: {
            title: 'Tasklaw - Nueva Marca',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: 'Tasklaw - Detalles de la Marca',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'Nueva Marca',
        titleDetail: 'Detalles de la Marca',
        data: 'Datos de la Marca',
        processNo: 'Núm. de Proceso',
        searchINPI: 'Buscar en INPI',
        processNumberRequired: 'Núm. de Proceso (Obligatorio)',
        processNumberIsRequired: 'El número de proceso es obligatorio',
        searchCompanyRequired: 'Buscar empresa (Obligatorio)',
        companyIsRequired: 'La empresa es obligatoria',
        inpiError: '¡Oops! Hubo un problema con INPI.',
        processNumber: 'Número de Proceso',
        situation: 'Situación',
        brand: 'Marca',
        presentation: 'Presentación',
        nature: 'Naturaleza'
    }
};

const client = {
    info: {
        primaryEmail: 'Correo Electrónico Principal',
        commercialPhone: 'Teléfono Comercial',
        cellPhone: 'Teléfono Celular',
        comments: 'Comentarios',
        isActive: {
            portfolio: '¿Está activo el portafolio?',
            department: '¿Está activo el departamento?'
        }
    },
    workedHours: {
        fromDate: 'Después de',
        toDate: 'Antes de',
        responsible: 'Filtrar por Responsable',
        dataTable: {
            itemName: 'hora trabajada',
            headers: {
                registeredAt: 'Fecha de Registro',
                demand: 'Demanda',
                workedHour: 'Horas Trabajadas',
                responsibleName: 'Responsable',
                actions: 'Acciones'
            },
            deleteSuccess: '¡Hora trabajada eliminada con éxito!'
        }
    },
    contracts: {
        addItem: 'Registrar Contrato',
        tabs: {
            active: 'Activo',
            inactive: 'Inactivo'
        },
        dataTable: {
            itemName: 'contrato',
            headers: {
                contract: 'Contrato',
                typePart: 'Parte',
                part: 'Parte Principal',
                deadline: 'Plazo Actual',
                validity: 'Vigencia',
                status: 'Estado',
                pendingAdditive: 'Adicional Pendiente'
            }
        }
    }
};

const portfolios = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.portfolios),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Registrar Portafolio',
        dataTable: {
            itemName: labels.portfolio.toLowerCase(),
            headers: {
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            }
        }
    },
    form: {
        meta: {
            title: common.meta.title.replace('%page', 'Registrar Portafolio'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Datos del Portafolio',
        name: {
            label: 'Nombre del Portafolio (Requerido)',
            required: 'El nombre es requerido',
            length: 'El nombre debe tener al menos 3 caracteres'
        },
        primaryEmail: {
            label: 'Correo Electrónico Principal (Requerido)',
            required: 'El correo es requerido',
            test: 'El correo debe ser válido'
        },
        commercialPhone: 'Teléfono Comercial',
        cellPhone: 'Teléfono Celular',
        comments: 'Comentarios'
    },
    teamMember: {
        addItem: 'Registrar Usuario',
        dataTable: {
            itemName: 'usuario',
            headers: {
                name: 'Usuario',
                jobTitle: 'Título del Trabajo',
                phone: 'Teléfono',
                username: 'Correo Electrónico',
                mainAccount: 'Tipo de Acceso',
                actions: 'Acciones'
            },
            deleteSuccess: '¡Relación eliminada con éxito!'
        },
        form: {
            meta: {
                title: common.meta.title.replace('%page', 'Registrar Usuario'),
                description: common.meta.description,
                keywords: common.meta.keywords
            },
            data: 'Datos del Usuario',
            name: {
                label: 'Nombre (Requerido)',
                required: 'El nombre es requerido',
                length: 'El nombre debe tener al menos 3 caracteres'
            },
            jobTitle: {
                label: 'Título del Trabajo (Requerido)',
                required: 'El título del trabajo es requerido',
                length: 'El título del trabajo debe tener al menos 3 caracteres'
            },
            phone: {
                label: 'Teléfono (Requerido)',
                required: 'El teléfono es requerido',
                length: 'El número de teléfono debe tener al menos 8 caracteres'
            },
            username: {
                label: 'Correo Electrónico (Requerido)',
                required: 'El correo es requerido',
                test: 'El correo debe ser válido'
            },
            pickColor: 'Elige un color',
            mainAccount: {
                label: '¿Administrador?',
                required: 'El tipo de acceso es requerido',
                items: {
                    admin: 'Administrador',
                    user: 'Usuario'
                }
            },
            errorUpdateAdmin: '¡Ocurrió un error al actualizar el estado de administrador!',
            errorRelation: '¡Ocurrió un error, la entidad legal fue creada pero no se vinculó a la organización!',
            errorCreate: '¡Ocurrió un error y no fue posible crear la entidad legal!'
        }
    }
};

const departments = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.departments),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Registrar Departamento',
        dataTable: {
            itemName: labels.department.toLowerCase(),
            headers: {
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            }
        }
    },
    form: {
        meta: {
            title: common.meta.title.replace('%page', 'Registrar Departamento'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Datos del Departamento',
        name: {
            label: 'Nombre del Departamento (Requerido)',
            required: 'El nombre es requerido',
            length: 'El nombre debe tener al menos 3 caracteres'
        },
        primaryEmail: {
            label: 'Correo Electrónico Principal (Requerido)',
            required: 'El correo es requerido',
            test: 'El correo debe ser válido'
        },
        commercialPhone: 'Teléfono Comercial',
        cellPhone: 'Teléfono Celular',
        comments: 'Comentarios',
        isActive: '¿Está activo el departamento?'
    },
    teamMember: {
        addItem: 'Registrar Miembro del Equipo',
        dataTable: {
            itemName: 'miembro del equipo',
            headers: {
                name: 'Miembro del Equipo',
                mainAccount: 'Tipo de Acceso',
                actions: 'Acciones'
            },
            deleteSuccess: '¡Relación con el departamento eliminada con éxito!'
        },
        form: {
            meta: {
                title: common.meta.title.replace('%page', 'Registrar Miembro del Equipo'),
                description: common.meta.description,
                keywords: common.meta.keywords
            },
            data: 'Datos del Miembro del Equipo',
            name: {
                label: 'Nombre (Requerido)',
                required: 'El nombre es requerido',
                length: 'El nombre debe tener al menos 3 caracteres'
            },
            jobTitle: {
                label: 'Título del Trabajo (Requerido)',
                required: 'El título del trabajo es requerido',
                length: 'El título del trabajo debe tener al menos 3 caracteres'
            },
            phone: {
                label: 'Teléfono (Requerido)',
                required: 'El teléfono es requerido',
                length: 'El número de teléfono debe tener al menos 8 caracteres'
            },
            username: {
                label: 'Correo Electrónico (Requerido)',
                required: 'El correo es requerido',
                test: 'El correo debe ser válido'
            },
            pickColor: 'Elige un color',
            mainAccount: {
                label: '¿Administrador?',
                required: 'El tipo de acceso es requerido',
                items: {
                    admin: 'Administrador',
                    user: 'Usuario'
                }
            },
            errorUpdateAdmin: '¡Ocurrió un error al actualizar el estado de administrador!',
            errorRelation: '¡Ocurrió un error, el usuario fue creado pero no se vinculó a la empresa!',
            errorCreate: '¡Ocurrió un error y no fue posible crear el usuario!',
            errorUploadAvatar: '¡Error al cargar el avatar!'
        }
    }
};

const legalTeam = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.legalTeam),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Registrar Equipo Legal',
        dataTable: {
            itemName: labels.legalTeam.toLowerCase(),
            headers: {
                avatar: 'Avatar',
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            },
            isInactiveMessage: '¿Está seguro de que desea desactivar esto?',
            isActiveMessage: '¿Está seguro de que desea activar esto?',
            fbActiveMessage: '¡Equipo legal activado con éxito!',
            fbInactiveMessage: '¡Equipo legal desactivado con éxito!'
        }
    },
    form: {
        metaNew: {
            title: common.meta.title.replace('%page', 'Registrar Equipo Legal'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaEdit: {
            title: common.meta.title.replace('%page', 'Editar Equipo Legal'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Datos del Equipo Legal',
        save: common.save,
        avatar: {
            placeholder: 'Avatar',
        },
        name: {
            placeholder: 'Nombre (Requerido)',
            errors: {
                required: 'El nombre es requerido',
                length: 'El nombre debe tener al menos 3 caracteres'
            }
        },
        email: {
            placeholder: 'Correo Electrónico (Requerido)',
            errors: {
                required: 'El correo es requerido',
                length: 'El correo debe ser válido'
            }
        },
        jobTitle: {
            placeholder: 'Título del Trabajo (Requerido)',
            errors: {
                required: 'El título del trabajo es requerido',
                length: 'El título del trabajo debe tener al menos 3 caracteres'
            }
        },
        phone:  {
            placeholder: 'Teléfono (Requerido)',
            errors: {
                required: 'El teléfono es requerido',
                length: 'El número de teléfono debe tener al menos 8 caracteres'
            }
        },
        selectColor: 'Elige un color',
        isAdmin: '¿Es administrador?',
        adminStatusUpdateError: '¡Ocurrió un error al actualizar el estado de administrador!',
        legalCreatedButNotLinkedError: '¡Ocurrió un error, el equipo legal fue creado pero no se vinculó a la organización!',
        legalCreationError: '¡Ocurrió un error y no fue posible crear el equipo legal!',
        avatarUploadError: '¡Error al cargar el avatar!'
    },
    detail: {
        meta: {
            title: common.meta.title.replace('%page', 'Detalles del Equipo Legal'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        tabs: {
            legalTeam: labels.legalTeam,
            demands: labels.demands,
            timeline: labels.timeline
        },
        fields: {
            admin: 'Administrador',
            name: 'Nombre',
            email: 'Correo Electrónico',
            jobTitle: 'Título del Trabajo',
            phone: 'Teléfono',
            activeDemands: labels.activeDemands,
            demandsCompleted: labels.demandsCompleted,
            workedHours: labels.workedHours
        }
    }
};

const notifications = {
    meta: {
        title: common.meta.title.replace('%page', labels.notifications),
        description: common.meta.description,
        keywords: common.meta.keywords
    },
    filter: {
        searchFor: common.filter.searchFor,
        byDepartment: common.filter.byDepartment,
        byResponsible: common.filter.byResponsible,
        clearFilter: common.filter.clearFilter,
        applyFilter: common.filter.applyFilter
    },
    sideMenu: {
        boxes: 'Cajas',
        my: 'Mis',
        distribution: 'Distribución',
        admin: 'Administrador',
        archived: 'Archivado',
        archivedAdmin: 'Administrador Archivado'
    },
    dotMenu: {
        markAllRead: 'Marcar todo como leído',
        archiveAll: 'Archivar todo'
    },
    tile: {
        demand: labels.demand,
        archiveActions: {
            archive: 'Archivar',
            unarchive: 'Desarchivar'
        },
        readActions: {
            markRead: 'Marcar como leído',
            markUnread: 'Marcar como no leído'
        },
        lastSeen: 'Última vez visto por el responsable actual el',
        neverSeen: 'Nunca',
        demandNotFound: '¡Demanda no encontrada o eliminada!'
    }
};

export default {
    labels,
    common,
    demand,
    contracts,
    corporate,
    brands,
    client,
    portfolios,
    departments,
    legalTeam,
    notifications,
    $vuetify: vuetify
}